import React, { ComponentType, useEffect, useState } from "react"

import { useAppData } from "@/app/providers/app_data.provider"
import { Spinner } from "@/components/layouts/spinner"

export function withAppData<P extends {}>(
  Component: ComponentType<P>
): React.FC<P> {
  return function WithAppData(props): JSX.Element {
    const appData = useAppData()

    // to avoid hydration errors, dont render anything until the useEffect() triggers on the client
    const [isHydrated, setIsHydrated] = useState<boolean>(false)
    useEffect(() => setIsHydrated(true), [])

    if (!isHydrated) return <></>

    // TODO: show error page if there are AppData loading errors
    return (
      <>
        {appData.isLoaded() && <Component {...(props as any)} />}
        {appData.isLoading() && <Loading progress={appData.progress()} />}
      </>
    )
  }
}

export function Loading({ progress }) {
  return <Spinner hasTitle title={`Loading Grafiniti... ${progress}%`} />
}
